<template>
    <div class="form-filter form-filter--sale">
        <form @submit.prevent="getfilteredData()">
            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <!-- Field: Search -->
                    <div class="field-wrap">
                        <label
                            for="field-search"
                        >
                            Area Search
                        </label>
                        <div class="field-wrap__input field-wrap__input--prepend field-wrap__input--prepend-fill">
                            <places
                                id="field-search"
                                v-model="search"
                                :options="{
                                    countries: ['gb'],
                                    language: 'en',
                                    type: 'city',
                                    aroundLatLngViaIP: false,
                                    templates: {
                                        value: function(suggestion) {
                                            return suggestion.name;
                                        }
                                    }
                                }"
                                placeholder="Search by Postcode or Location"
                                name="field-search"
                                @change="val => { searchData = val }"
                            />

                            <div class="field-wrap__input-icon">
                                <SVGSprite
                                    name="search"
                                    class="form-icon"
                                />
                            </div>
                        </div>
                    </div>
                    <!-- END Field: Search -->
                </b-col>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-row>
                        <b-col cols="6">
                            <!-- Field: Min bedrooms -->
                            <div class="field-wrap">
                                <label
                                    for="field-min-beds"
                                >
                                    Min Bedrooms
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-min-beds"
                                        v-model="min_beds"
                                        name="field-min-beds"
                                    >
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            hidden
                                        >
                                            Select
                                        </option>
                                        <option :value="0">
                                            No Minimum
                                        </option>
                                        <option :value="1">
                                            1
                                        </option>
                                        <option :value="2">
                                            2
                                        </option>
                                        <option :value="3">
                                            3
                                        </option>
                                        <option :value="4">
                                            4
                                        </option>
                                        <option :value="5">
                                            5
                                        </option>
                                        <option :value="6">
                                            6+
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- END Field: Min bedrooms -->
                        </b-col>
                        <b-col cols="6">
                            <!-- Field: Max bedrooms -->
                            <div class="field-wrap">
                                <label
                                    for="field-max-beds"
                                >
                                    Max Bedrooms
                                </label>
                                <div class="field-wrap__input field-wrap__input--select">
                                    <select
                                        id="field-max-beds"
                                        v-model="max_beds"
                                        name="field-max-beds"
                                    >
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            hidden
                                        >
                                            Select
                                        </option>
                                        <option :value="0">
                                            No Maximum
                                        </option>
                                        <option :value="1">
                                            1
                                        </option>
                                        <option :value="2">
                                            2
                                        </option>
                                        <option :value="3">
                                            3
                                        </option>
                                        <option :value="4">
                                            4
                                        </option>
                                        <option :value="5">
                                            5
                                        </option>
                                        <option :value="6">
                                            6+
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!-- END Field: Max bedrooms -->
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>


            <b-row>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <b-row>
                        <b-col cols="6">
                            <!-- Field: Price from -->
                            <div class="field-wrap">
                                <label
                                    for="price_from"
                                >
                                    Price from
                                </label>
                                <p class="mb-0 color-secondary text-bold">
                                    <span class="range-slider-value">{{ priceFromValue | price(false) }}</span>
                                </p>
                                <div class="field-wrap__input field-wrap__input--range">
                                    <input
                                        id="price_from"
                                        ref="priceFrom"
                                        v-model.number="price_from"
                                        type="range"
                                        name="price_from"
                                        min="0"
                                        :max="priceScales.length - 1"
                                        step="1"
                                    >
                                </div>
                            </div>
                            <!-- END Field: Price from -->
                        </b-col>
                        <b-col cols="6">
                            <!-- Field: Price to -->
                            <div class="field-wrap">
                                <label
                                    for="price_to"
                                >
                                    Price to
                                </label>
                                <p class="mb-0 color-secondary text-bold">
                                    <span class="range-slider-value">{{ priceToValue | price(false) }}</span>
                                </p>
                                <div class="field-wrap__input field-wrap__input--range">
                                    <input
                                        id="price_to"
                                        ref="priceTo"
                                        v-model.number="price_to"
                                        type="range"
                                        name="price_to"
                                        min="0"
                                        :max="priceScales.length - 1"
                                        step="1"
                                    >
                                </div>
                            </div>
                            <!-- END Field: Price to -->
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                    cols="12"
                    lg="6"
                >
                    <div class="d-flex justify-content-lg-end">
                        <!-- Field: Checkbox -->
                        <div class="field-wrap w-auto">
                            <div class="field-wrap__input field-wrap__input--checkbox">
                                <input
                                    id="field-checkbox"
                                    v-model="toggle"
                                    type="checkbox"
                                    true-value="true"
                                    false-value="false"
                                    name="field-checkbox"
                                >
                                <label for="field-checkbox"><span class="check-element" />Include under offer, Sold STC</label>
                            </div>
                        </div>
                        <!-- END Field: Checkbox -->
                    </div>
                    <div class="d-flex justify-content-between justify-content-lg-end">
                        <!-- Clear filter -->
                        <button
                            type="button"
                            class="btn btn--nomin btn--outline mt-4 mr-3 mt-md-0"
                            @click="clearFilters()"
                        >
                            Clear Filters
                        </button>
                        <!-- END Clear filter -->

                        <!-- Submit filter -->
                        <button
                            type="submit"
                            class="btn btn--secondary mt-4 mt-md-0"
                        >
                            Search Properties
                        </button>
                        <!-- END Submit filter -->
                    </div>
                </b-col>
            </b-row>
        </form>
    </div>
</template>

<script>
import Places from 'vue-places';

function buildPriceScale() {
    const scales = [0, 100000];
    const incrementValue = 25000;

    while (scales[(scales.length - 1)] < 20000000) {
        const lastValue = scales[(scales.length - 1)];
        let increaseValue;

        if (lastValue < 1000000) {
            increaseValue = 25000;
        }
        else {
            increaseValue = 250000;
        }

        scales.push((lastValue + increaseValue));
    }

    return scales;
}

export default {
    name: 'SearchSaleForm',
    components: {
        Places
    },
    data() {
        return {
            search: null,
            searchData: {},
            min_beds: 0,
            max_beds: 0,
            price_from: 0,
            price_to: null,
            toggle: false,
            priceScales: buildPriceScale()
        };
    },
    computed: {
        priceFromValue() {
            try {
                return this.priceScales[this.price_from];
            } catch (e) {
                return 0;
            }
        },
        priceToValue() {
            try {
                return this.priceScales[this.price_to];
            } catch (e) {
                return 0;
            }
        }
    },
    mounted() {
        // on vue mounted get initial values for range sliders
        // this.getRangeLabel(null, this.$refs.priceFrom);
        // this.getRangeLabel(null, this.$refs.priceTo);
        this.price_to = this.priceScales.length - 1;
    },
    methods: {
        // Format passed integer with commas
        formatWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // Update the label value of range sliders
        getRangeLabel(ev, el) {
            const self = el || ev.target; // dom range element
            const selfId = self.getAttribute('id'); // element ID
            const label = document.getElementById(`${selfId}-label`); // corresponding label
            const value = this.formatWithCommas(self.value); // formatted value
            label.innerHTML = value; // change label html to new value
        },
        // Get the filtered data and emit to parent component
        getfilteredData() {
            const filters = {
                type: 'sale',
                search: this.search,
                min_beds: this.min_beds,
                max_beds: this.max_beds,
                price_from: this.priceFromValue || null,
                price_to: this.priceToValue || null,
                toggle: this.toggle
            };
            this.$emit('filterProperties', filters);
        },
        clearFilters() {
            this.search = null;
            this.min_beds = 0;
            this.max_beds = 0;
            this.price_from = 0;
            this.price_to = this.priceScales.length - 1;
            this.toggle = null;
            this.$emit('filterProperties', {});
        }
    }
};
</script>

<style lang="scss">
.ap-input {
    height: auto !important;
    line-height: normal !important;
}
</style>
